<style lang="scss" scoped="scoped">
// ::-webkit-scrollbar {
// 	width: 0 !important
// }
::-webkit-scrollbar {
  display: none;
}

.vue-grid-item {
  background: #202027;
  // overflow: auto;
  box-sizing: border-box;
  position: relative;
}

.vue-grid-item.vue-grid-placeholder {
  background: #419fff !important;
}

.el-dropdown-link {
  cursor: pointer;
  color: #419fff;
}

.bg {
  background: rgb(18, 18, 18);
}

// .vue-grid-layout::-webkit-scrollbar {
// 	width: 0 !important
// }

.module-grid {
  background: #202027;
}
</style>
<style lang="scss">
.el-popper {
  margin-right: 10px;
}

.monitorWorshop .el-input__inner {
  color: #419fff;
  border: none;
  background-color: transparent;
  text-align: right;
  width: 260px;
}

.monitorWorshop .el-cascader .el-input .el-icon-arrow-down {
  color: #419fff;
}

.monitorWorshop .el-input__inner::-webkit-input-placeholder {
  color: #419fff;
}
</style>
<template>
  <div style="display: inline;">
    <div class="bg" style="position: absolute;height: 100%;width: 100%;box-sizing: border-box;">
      <div ref="header" style="padding: 34px 34px  0px  34px;">
        <div class="module-grid" style="border-radius: 2px;width: 100%;height: 66px;padding:0px 20px;display: flex;justify-content: space-between;align-items: center;">
          <div style="width: 340px;cursor: pointer;">
            <img @click="utils.event_hub.$emit('TOGGLE_TABBAR', !store.state.is_monitor_full)" style="width: auto;height: 38px;" src="../../../../../../assets/img/web/xiangjiao/xiangjiao_logo.png" />
          </div>
          <div style="font-weight: 700;font-size: 30px;color: white;">
            {{ $t('huanyilaidaoyizhimiyazhushebeizhanwei') }}
          </div>
          <div class="monitorWorshop" style="width: 340px;display: flex;flex-direction: column;justify-content: center;align-items: flex-end;">
            <div style="display: flex;align-items: center;">

              <!-- <img @click="changeLang()" style="width: auto;height: 18px;margin-left: 8px;cursor: pointer;" src="../../../../../../assets/img/web/xiangjiao/xiangjiao_lang.png" /> -->

              <img @click="changeTemplate()" style="width: auto;height: 18px;margin-left: 20px;cursor: pointer;" src="../../../../../../assets/img/web/xiangjiao/xiangjiao_next.png" />

              <!-- <yi_data_select v-show="false" :type="'organization'" :ids.sync="orgId"> </yi_data_select> -->

            </div>
            <p style="font-size: 14px;color:white;">{{ store.state.currentTime }}</p>

          </div>
        </div>
      </div>
      <div style="padding: 0px 14px 34px  14px;">
        <grid-layout v-if="gridContainerHeight != 0" :layout.sync="layout" :col-num="24" :maxRows="24" :row-height="gridRowHeihgt" :is-mirrored="false" :vertical-compact="false" :margin="[20, 20]" :use-css-transforms="true" :is-draggable="false" :is-resizable="false" :style="{ height: gridContainerHeight + 'px' }" style="overflow: hidden;">
          <grid-item @resized="resizedGrid" v-for="item in layout" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i" :key="item.i">
            <component :datas="datas" :cockpitData="cockpitData" :v440fData="v440fData" :h300fData="h300fData" :ref="'grid_' + item.i" v-bind:is="item.i"> </component>
          </grid-item>
        </grid-layout>
      </div>
    </div>
    <el-dialog :show-close="true" :title="$t('kanbanshezhi')" :visible.sync="isShowBoardEdit" :close-on-click-modal="false" width="874px" append-to-body>
      <setting ref="setting"></setting>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowBoardEdit = false">{{ $t("quxiao") }}</el-button>
        <el-button size="mini" @click="
          $refs.setting.save();
        isShowBoardEdit = false;
        " type="primary">
          {{ $t("baocun") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import VueGridLayout from "vue-grid-layout";
import quota from "@@/pages/web/customize/xiangjiao/monitor/rubber/quota";
import kaijilv from "@@/pages/web/customize/xiangjiao/monitor/rubber/kaijilv";
import liangpinlv from "@@/pages/web/customize/xiangjiao/monitor/rubber/liangpinlv";
import jiadonglv from "@@/pages/web/customize/xiangjiao/monitor/rubber/jiadonglv";
import chanliang from "@@/pages/web/customize/xiangjiao/monitor/rubber/chanliang";
import jihuakaiji from "@@/pages/web/customize/xiangjiao/monitor/rubber/jihuakaiji";

export default {
  name: "web_customize_xiangjiaoji_monitor_rubber_index",
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    kaijilv: kaijilv,
    liangpinlv: liangpinlv,
    jiadonglv: jiadonglv,
    quota: quota,
    chanliang: chanliang,
    jihuakaiji: jihuakaiji,
  },

  data() {
    return {
      orgId: this.store.state.organizations[0].id,
      isShowBoardEdit: false,
      datas: {},
      gridContainerHeight: 0,
      gridRowHeihgt: 0,
      layout: [],
      cockpitData: {},
      v440fData: [],
      h300fData: [],
    };
  },
  watch: {
    orgId(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.getCockpit();
    },
  },
  created() {
    this.setLayout();

    this.timmer = setInterval(() => {
      this.getCockpit();
    }, 600000);
    this.getCockpit();
  },
  activated() {
    this.resize();
  },
  mounted() {

    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  destroyed() {

    if (this.timmer) {
      clearInterval(this.timmer);
    }
  },
  methods: {
    changeLang() {
      //在中文，英文，德文之间切换

      if (this.lang == "zh_CN") {
        localStorage.setItem("lang", "en_US");
      } else if (this.lang == "en_US") {
        localStorage.setItem("lang", "de_DE");
      } else {
        localStorage.setItem("lang", "zh_CN");
      }
      window.location.reload();

    },
    setLayout() {
      this.monitorSetting = JSON.parse(localStorage.getItem("MONITOR_SETTING"));
      if (this.monitorSetting == null) {
        this.monitorSetting = {};
      }

      if (this.monitorSetting.MONITOR_XIANGJIAO_RUBBER_TEMPLATE == null) {
        this.monitorSetting.MONITOR_XIANGJIAO_RUBBER_TEMPLATE = "moren";
      }
      if (this.monitorSetting.MONITOR_XIANGJIAO_RUBBER_TEMPLATES == null) {
        this.monitorSetting.MONITOR_XIANGJIAO_RUBBER_TEMPLATES = {
          moren: [
            {
              x: 0,
              y: 0,
              w: 24,
              h: 12,
              i: "quota",
            },
            {
              x: 0,
              y: 12,
              w: 8,
              h: 12,
              i: "kaijilv",
            },
            {
              x: 8,
              y: 12,
              w: 8,
              h: 12,
              i: "jiadonglv",
            },
            {
              x: 16,
              y: 12,
              w: 8,
              h: 12,
              i: "liangpinlv",
            },
          ],
          moren2: [
            {
              x: 0,
              y: 0,
              w: 24,
              h: 12,
              i: "quota",
            },
            {
              x: 0,
              y: 12,
              w: 12,
              h: 12,
              i: "chanliang",
            },
            {
              x: 12,
              y: 12,
              w: 12,
              h: 12,
              i: "jihuakaiji",
            },
          ],
        };
      }

      this.layout = this.monitorSetting.MONITOR_XIANGJIAO_RUBBER_TEMPLATES[this.monitorSetting.MONITOR_XIANGJIAO_RUBBER_TEMPLATE];
      this.$nextTick(() => {
        this.utils.event_hub.$emit("RESIZE");
      });
    },
    async getCockpit() {



      let response = await this.http.get("/custom/kshow/getDeviceData", {
      });
      let response2 = await this.http.get("/web/report/page/quality_cockpit", {
        params: {
          orgId: this.orgId,
        },
      });
      let response3 = await this.http.get("/web/equipment/getEquipmentShiftHourProductBySn?sn=S0200C0761", {
      });
      let response4 = await this.http.get("/web/equipment/getEquipmentShiftHourProductBySn?sn=S0160C1023", {
      });

      console.log(response3.data, response4.data)
      // YL3-V440F是506R001，YL2-H300F是536R001

      this.datas = response.data;
      this.cockpitData = response2.data.extend;
      this.v440fData = response3.data;
      this.h300fData = response4.data;



      this.utils.event_hub.$emit("RESIZE");


    },
    showBoardEdit() {
      this.isShowBoardEdit = true;
      this.$nextTick(() => {
      });
    },
    resizedGrid(i) {
      this.$refs["grid_" + i][0].resize();
    },

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.header) {
          return;
        }
        this.gridContainerHeight = this.store.state.router_view_height - this.$refs.header.offsetHeight - 34;
        this.gridRowHeihgt = (this.gridContainerHeight - 480) / 24;
      }, 500);
    },
    changeTemplate() {
      if (this.monitorSetting.MONITOR_XIANGJIAO_RUBBER_TEMPLATE == "moren2") {
        this.monitorSetting.MONITOR_XIANGJIAO_RUBBER_TEMPLATE = "moren";
      } else {
        this.monitorSetting.MONITOR_XIANGJIAO_RUBBER_TEMPLATE = "moren2";
      }
      this.layout = this.monitorSetting.MONITOR_XIANGJIAO_RUBBER_TEMPLATES[this.monitorSetting.MONITOR_XIANGJIAO_RUBBER_TEMPLATE];
      this.$nextTick(() => {
        this.utils.event_hub.$emit("RESIZE");
      });
    },
  },
};
</script>
